const Blade = (props) => {
  const cta = (
      <div className="mx-auto w-full lg:w-1/2 lg:self-center lg:text-left">
        <div className="xl:pr-2">
          <h2 className="font-secondary tracking-tight text-center lg:text-left text-headline-2 md:text-headline-2-md 2xl:text-headline-2-lg">
            <span className="block xl:inline">{ props.title }</span>
          </h2>
          <p className="font-primary mt-3 mx-auto text-center text-body-1 md:text-body-1-md 2xl:text-body-1-lg lg:text-left lg:mt-5 lg:max-w-3xl">{ props.subtitle }</p>
        </div>
      </div>

  )
  const image = (
      <div className="lg:w-1/2 mt-6 lg:mt-0">
        <img
          className=""
          src={props.image}
          alt={props.alt}
        />
      </div>
  )

  return (
    <>
      {!props.reversed &&
        <div className="xl:mx-28 lg:mt-16 flex flex-col lg:flex-row lg:space-x-4 lg:relative">
          {cta}
          {image}
        </div>
      }
      {props.reversed &&
        <div className="xl:mx-28 lg:mt-16 flex flex-col-reverse lg:flex-row lg:space-x-4 lg:relative">
          {image}
          {cta}
        </div>
      }
    </>
  )
}

export default Blade;

